import {IProductTabItem} from '../interface'

export const productTabItems: IProductTabItem[] = [
  {
    key: 'product_detail_tab_generic_properties_tab',
    label: 'product_detail_tab_generic_properties_tab',
  },
  {
    key: 'product_detail_tab_locale_properties_tab',
    label: 'product_detail_tab_locale_properties_tab',
  },
  {
    key: 'product_detail_tab_stockLevel',
    label: 'product_detail_tab_stockLevel',
  },
  {
    key: 'product_detail_tab_price',
    label: 'product_detail_tab_price',
  },
  {
    key: 'product_detail_tab_marketplace',
    label: 'product_detail_tab_marketplace',
  },
]

export const productTabItemsMaster: IProductTabItem[] = [
  {
    key: 'product_detail_tab_generic_properties_tab',
    label: 'product_detail_tab_generic_properties_tab',
  },
  {
    key: 'product_detail_tab_locale_properties_tab',
    label: 'product_detail_tab_locale_properties_tab',
  },
  {
    key: 'product_detail_tab_variant',
    label: 'product_detail_tab_variant',
  }
]